module.exports = __webpack_public_path__ + "static/media/glassWire.52e4a0a8.png";